import type { TopLevelMenuItem } from '../../types';
import { useState } from 'react';
import { SidebarMenuItem } from './SidebarMenuItem';
import { MenuList } from './Sidebar.styles';
import { findActiveItem } from './Sidebar.utils';

export interface SidebarMenuProps {
  items: TopLevelMenuItem[];
}

export function SidebarMenu({ items }: SidebarMenuProps) {
  const [expandedItemHref, setExpandedItemHref] = useState(() => findActiveItem(items)?.href ?? null);

  return (
    <MenuList>
      {items.map((item) => (
        <li key={item.text}>
          <SidebarMenuItem isExpanded={expandedItemHref === item.href} onExpand={setExpandedItemHref} {...item} />
        </li>
      ))}
    </MenuList>
  );
}
